import { G_activeTriggerElements } from "../../../utils/globals/globals";
import run from "../../animate/run";

/**
 * Pointer up
 * @param {CustomEventProps} event
 */
const pointerup = (event) => {
  for (const original of G_activeTriggerElements) {
    const main = /** @type {MainClassProps} */ (original);
    const active = main.applied.get("active");

    G_activeTriggerElements.delete(main);

    for (const trigger of active) {
      const event = main.events.get(`pointerdown:${trigger}`);

      run(event, "leave", false);
    }
  }
};

export default pointerup;
